<template>
  <div>
    <v-text-field
      @click:prepend="sub"
      @click:append-outer="add"
      prepend-icon="mdi-minus"
      append-outer-icon="mdi-plus"
      :value="counter"
      hide-details
    ></v-text-field>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data: () => ({
    counter: null
  }),
  methods: {
    changeValue(newVal) {
      this.$emit("input", newVal);
    },

    // Decrement counter
    sub() {
      if (this.counter < 1) {
        this.counter = 1;
      }

      this.counter--;
      this.$emit("input", this.counter);
    },

    // Increment counter
    add() {
      this.counter++;
      this.$emit("input", this.counter);
    }
  },
  created() {
    this.counter = this.value;
  }
};
</script>